import API_URL from '@/config/api';
import { formatApiError } from '@/utils/apiError';

async function req(method, path, body) {
  const r = await fetch(`${API_URL}/api${path}`, { method, credentials: 'include', headers: body ? { 'Content-Type': 'application/json' } : undefined, body: body ? JSON.stringify(body) : undefined });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(formatApiError(d) || 'Request failed');
  return d;
}

export const wget = (p) => req('GET', p);
export const wpost = (p, b) => req('POST', p, b || {});
export const wput = (p, b) => req('PUT', p, b || {});
export const wpatch = (p, b) => req('PATCH', p, b || {});
export const wdel = (p) => req('DELETE', p);

export async function wupload(path, file) {
  const fd = new FormData();
  fd.append('file', file);
  const r = await fetch(`${API_URL}/api${path}`, { method: 'POST', credentials: 'include', body: fd });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(formatApiError(d) || 'Upload failed');
  return d;
}

export const orderFileUrl = (orderId, fileId) => `${API_URL}/api/website/orders/${orderId}/files/${fileId}`;
export const templateImageUrl = (templateId, imageId) => `${API_URL}/api/website/templates/${templateId}/images/${imageId}`;
export const templateDemoUrl = (templateId) => `${API_URL}/api/website/templates/${templateId}/demo/`;

export const STATUS_FLOW = ['submitted', 'info_required', 'in_development', 'ready_for_review', 'changes_requested', 'approved', 'live'];
export const STATUS_TONE = {
  draft: 'bg-slate-100 text-slate-700', submitted: 'bg-sky-100 text-sky-800', info_required: 'bg-amber-100 text-amber-800', in_development: 'bg-indigo-100 text-indigo-800',
  ready_for_review: 'bg-purple-100 text-purple-800', changes_requested: 'bg-orange-100 text-orange-800', approved: 'bg-emerald-100 text-emerald-800', live: 'bg-green-600 text-white',
};
export const FILE_CATEGORY_LABELS = { logo: 'Logo', branding: 'Branding files', projects: 'Completed projects', before_after: 'Before & after', team: 'Team / company', vehicles: 'Vehicles & signage', other: 'Other images' };
